// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonUnits = {
  question: "questions",
  score: "points",
  minutes: "minutes",
} as const;
